export const AGENT_CHECK_NOTIFICATION = {
  canceled: 'Отменить',
  snackbarTitle: 'Количество пометок меньше, чем количество ',
  titleInoagent: 'иноагентов:',
  titleExtremist: 'экстремистов:',
  alertTitle: (actionType: string): string => `Вы точно хотите ${actionType.toLowerCase()} новость?`,
  errorTitle: 'Проверка иноагентов не сработала, перепроверьте текст вручную!'
}
